import {gql} from '@apollo/client';

export const SUBMIT_CUSTOMER_COMPLAINT_APPEAL = gql`
    mutation SubmitCustomerComplaintAppeal(
        $complaintId: Long!,
        $appealReason: String!,
        $appealAttachmentS3KeysJson: String
    ) {
        submitCustomerComplaintAppeal(
            complaintId: $complaintId,
            appealReason: $appealReason,
            appealAttachmentS3KeysJson: $appealAttachmentS3KeysJson
        )
    }
`;

export interface SubmitCustomerComplaintAppealResponse {
    submitCustomerComplaintAppeal: number;
}

export interface SubmitCustomerComplaintAppealVariables {
    complaintId: number;
    appealReason: string;
    /** S3 key 列表 ["s3_key1","s3_key2",...] */
    appealAttachmentS3KeysJson?: string;
}

export const ACKNOWLEDGE_CUSTOMER_COMPLAINT = gql`
    mutation AcknowledgeCustomerComplaint($complaintId: Long!) {
        acknowledgeCustomerComplaint(complaintId: $complaintId)
    }
`;

export interface AcknowledgeCustomerComplaintResponse {
    acknowledgeCustomerComplaint: boolean;
}

export interface AcknowledgeCustomerComplaintVariables {
    complaintId: number;
}

export const ABANDON_CUSTOMER_COMPLAINT_APPEAL = gql`
    mutation AbandonCustomerComplaintAppeal($complaintId: Long!) {
        abandonCustomerComplaintAppeal(complaintId: $complaintId)
    }
`;

export interface AbandonCustomerComplaintAppealResponse {
    abandonCustomerComplaintAppeal: boolean;
}

export interface AbandonCustomerComplaintAppealVariables {
    complaintId: number;
}
